import { Injectable } from '@angular/core';
import { GeometricFormQuery } from '../../state/geometric-form.query';
import { GeometricFormType } from '../../state/geometric-form.type';
import { BuildingStore } from './building.store';
import { Building } from './building.model';

@Injectable({ providedIn: 'root' })
export class BuildingQuery extends GeometricFormQuery<Building> {

  type: GeometricFormType = 'mitra-building';
  isLoading$ = this.selectLoading();

  constructor(protected store: BuildingStore) {
    super(store);
  }

}
